// extracted by mini-css-extract-plugin
export var component = "SectionHeader-module--component--loUNM";
export var title = "SectionHeader-module--title--k+LOA";